/**
 * Home for the hidden media the room mounts by hand: the audio sinks the spatial
 * graph plays through, the mic-test monitor, and the offscreen element that
 * keeps GIF reactions animating.
 *
 * None of it goes into `<body>`. Under the SSR shell in `routes/__root.tsx`
 * React owns every `<body>` child, so a node appended straight to the body sits
 * in React's reconciliation range, and a later render throws
 * `NotFoundError: insertBefore` while it moves a sibling. `RootShell` renders
 * this container as a childless element, so React never reconciles what we
 * append into it.
 *
 * `id` lets a caller find that rendered container. The fallback covers the
 * contexts that have no shell to clash with — unit tests, isolated mounts —
 * where a plain detached-from-React container is enough.
 */
export const MEDIA_HOST_ID = "syncani-media-host";

/** The container hidden media elements are appended to. */
export function mediaHost(): HTMLElement {
  const rendered = document.getElementById(MEDIA_HOST_ID);
  if (rendered) return rendered;

  const host = document.createElement("div");
  host.id = MEDIA_HOST_ID;
  host.style.cssText =
    "position:fixed;width:0;height:0;overflow:hidden;pointer-events:none;";
  document.body.appendChild(host);
  return host;
}
